import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faTrashAlt,
	faChevronRight,
	faClipboardList,
	faFileAlt,
	faQuestionCircle,
	faProjectDiagram,
	faHome,
	faTasks,
	faBookOpen,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "../../../../hooks";
import styles from "./AssessmentItem.module.css";

// Get icon for assessment type
const getAssessmentTypeIcon = (type) => {
	switch (type?.toLowerCase()) {
		case "exam":
			return faFileAlt;
		case "quiz":
			return faQuestionCircle;
		case "project":
			return faProjectDiagram;
		case "homework":
			return faHome;
		case "activity":
			return faTasks;
		case "book report":
			return faBookOpen;
		default:
			return faClipboardList;
	}
};

const AssessmentItem = ({ assessment, onDelete, onClick }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.assessmentItem} onClick={() => onClick(assessment)}>
			<div className={styles.assessmentItemHeader}>
				<div className={styles.assessmentType}>
					<FontAwesomeIcon
						icon={getAssessmentTypeIcon(assessment.type)}
						className={styles.assessmentTypeIcon}
					/>
					{assessment.type}
				</div>
			</div>

			<div className={styles.assessmentItemBody}>
				<h3 className={styles.assessmentItemTitle}>{assessment.title}</h3>

				<div className={styles.assessmentMeta}>
					<div className={styles.assessmentPoints}>
						{assessment.points}
						<span className={styles.assessmentPointsLabel}>
							{t("assessment.pointsLabel") || "points"}
						</span>
					</div>

					<div className={styles.assessmentActions}>
						<button
							className={`${styles.actionBtn} ${styles.delete}`}
							onClick={(e) => onDelete(e, assessment.id)}
							title={t("assessment.deleteAssessment") || "Delete Assessment"}
						>
							<FontAwesomeIcon icon={faTrashAlt} />
						</button>
						<button
							className={`${styles.actionBtn} ${styles.grade}`}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								onClick(assessment);
							}}
							title={t("assessment.gradeAssessments") || "Grade Assessment"}
						>
							<FontAwesomeIcon icon={faChevronRight} />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AssessmentItem;
